import { FC } from "react";

import { MenuToggleProps } from "../types";

const Reports: FC<MenuToggleProps> = () => <></>
export default Reports;